import React, { useState } from 'react';
import styles from '../../styles/components/FeaturedDetails.module.css';

function FeaturedDetails({ featured, onClose }) {
  const [mainImage, setMainImage] = useState(featured.images[0]);

  if (!featured) {
    return null;
  }

  const images = featured.images || [];

  return (
    <div className={styles.featuredDetails}>
      <button className={styles.closeButton} onClick={onClose}>&times;</button>
      <div className={styles.contentWrapper}>
        <div className={styles.imageContainer}>
          <div className={styles.imageMain}>
            <img 
              src={mainImage} 
              alt={`${featured.name} - Main`} 
              className={styles.mainImage}
            />
          </div>
          Hover over images below.
          <div className={styles.imageGrid}>
            {images.map((image, index) => (
              <div 
                key={index} 
                className={`${styles.detailImageContainer} ${styles[`image${index + 1}`]}`}
                onMouseEnter={() => setMainImage(image)}
                onMouseLeave={() => setMainImage(images[0])}
              >
                <div className={styles.imageHoverContainer}>
                  <img 
                    src={image} 
                    alt={`${featured.name} - Image ${index + 1}`} 
                    className={styles.detailImage}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.productInfo}>
          <h2>{featured.name}</h2>
          <p>{featured.description}</p>
          {featured.link && (
            <a href={featured.link} target="_blank" rel="noopener noreferrer" className={styles.amazonButton}>
              Find it on Amazon
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default FeaturedDetails;